import { render } from "./MyTimelineItem.vue?vue&type=template&id=2fcbca24&bindings={}"
import script from "./MyTimelineItem.vue?vue&type=script&lang=ts"
export * from "./MyTimelineItem.vue?vue&type=script&lang=ts"

import "./MyTimelineItem.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script